export { DetailsDescription } from './DetailsDescription';
